export default __webpack_public_path__ + "static/media/Green0003.d8f0db34.png";